var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sidebar"},[_c('el-scrollbar',{staticClass:"sidebar__scrollbar",attrs:{"wrap-class":"sidebar__scrollbar--wrapper"}},[_c('Menu')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }